<template lang="pug">
  nav#sidebar.page-sidebar(@mouseenter='changeHover(true)',@mouseleave='changeHover(false)' @touchstart='touchStart' @touchmove='touchMove' @touchend='touchEnd')
    SidebarHeader(
      :systemMenuShow="systemMenuShow"
      :menuActive='menuActive'
      @toggleSystemMenu="toggleSystemMenu")
    NavList(:navTree="systemNavTree")
    SystemMenu(:navTree="navTree",:isShow="systemMenuShow",@changeSystem="changeSystem")
</template>

<script>
import { mapMutations } from 'vuex'
import { fullPath } from '../nav'
import { treeFormat } from '@/utils/common'

import SidebarHeader from './Header'
import NavList from './NavList'
import SystemMenu from './SystemMenu'

var status = false

export default {
  name: 'Sidebar',
  components: {
    SidebarHeader,
    NavList,
    SystemMenu
  },
  props: {
    routesPure: Array,
    menuActive: Boolean
  },
  data () {
    return {
      systemMenuShow: false
    }
  },
  computed: {
    currentFullPath () {
      return fullPath(this.$route, this.routesPure).map(item => item.url)
    },
    navList () {
      return this.routesPure.map(item => {
        const isPath = this.currentFullPath.indexOf(item.url) > -1
        item.isOpen = isPath
        item.isCurrent = isPath
        return item
      })
    },
    navTree () {
      return treeFormat(this.navList.filter(item => item.type !== 'BUTTON'))
    },
    systemNavTree () {
      return this.navTree.find(nav => {
        return this.currentFullPath[0] === nav.url
      }).children
    }
  },
  methods: {
    ...mapMutations([
      'toggleMenu'
    ]),
    toggleSystemMenu () {
      this.systemMenuShow = !this.systemMenuShow
    },
    changeSystem (url) {
      this.$router.push(url)
      this.systemMenuShow = false
    },
    changeHover (state) {
      this.$emit('changeHover', state)
    },
    touchStart (e) {
      this.startX = e.touches[0].clientX
      this.startY = e.touches[0].clientY
      status = false
    },
    touchMove (e) {
      // e.preventDefault()
      this.moveX = e.touches[0].clientX
      this.moveY = e.touches[0].clientY
      if (this.startX - this.moveX >= 10) {
        status = true
      }
    },
    touchEnd (e) {
      // e.preventDefault()
      if (status) {
        console.log('你在往左滑')
        this.toggleMenu()
      }
    }
  }
}
</script>

<style lang="sass">

.page-sidebar
  .sidebar-header-controls
    transform: translate(-70px, 0)
.sidebar-visible .page-sidebar,
.sidebarAct
  transform: translate(130px, 0)
  .sidebar-header-controls
    transform: translate(0, 0)
</style>



// WEBPACK FOOTER //
// index.vue?3741f07e